import script from "./BlogPostQuestionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostQuestionsSection.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostQuestionsSection.vue?vue&type=style&index=0&id=3ca07000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca07000"]])

export default __exports__